<template>
  <b-modal
    id="template-chart-modal"
    ref="templateMessageChartModal"
    :title="`${keyword} Notification Analytics`"
    modal-class="template-chart-modal"
    hide-footer
    size="lg">
    <BarChart
      :styles="{'height' : '300px'}"
      :options="chartOptions"
      :chart-data="templateChartData"
      chart-id="template-message-chart"
      class="mb-4"/>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BarChart from '../../../common/charts/Bar';

export default {
  name: 'TemplateMessageChartModal',
  components: {
    BarChart,
  },
  props: {
    chartLabels: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      templateChartData: {},
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          labels: {
            usePointStyle: true,
            fontColor: '#253756',
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          // xAxes: [{
          // }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          }],
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      analytics: 'notification/templateAnalytics',
    }),
  },
  watch: {
    analytics(analytics) {
      this.fillChartData(analytics);
    },
  },
  methods: {
    ...mapActions({
      fetchTemplateAnalytics: 'notification/fetchTemplateAnalytics',
    }),
    loadAnalytics(template) {
      this.keyword = template.keyword;
      this.fetchTemplateAnalytics({
        merchant_id: this.$route.params.merchant_id,
        keyword: template.keyword,
        data: this.dates,
      });
    },
    fillChartData(analytics) {
      this.templateChartData = {
        labels: this.chartLabels,
        datasets: [
          {
            label: 'All Sent',
            backgroundColor: 'rgba(61, 139, 252, 0.45)',
            borderColor: 'rgb(61, 139, 252)',
            data: Object.values(analytics.sent),
          },
          {
            label: 'All Failed',
            backgroundColor: 'rgb(237, 116, 116, 0.45)',
            borderColor: 'rgb(237, 116, 116)',
            data: Object.values(analytics.failed),
          },
        ],
      };
    },
    show() {
      this.$refs.templateMessageChartModal.show();
    },
    hide() {
      this.$refs.templateMessageChartModal.hide();
    },
  },
};
</script>
